import React from 'react';
import './OtpVerification.scss';

const OtpVerification = ({ headerImage, imgContainerClass, headerText, otpText, phoneNumber, footerText, footerTextColor = '', children }) => {
    const formattedFooterText = footerText.split("\n").map((w, i) => (
        <span key={i} style={{ display: 'block' }}>{w}</span>
    ));

    return (
        <>
            <div className={`image-container${imgContainerClass}`}>
                <img src={headerImage} alt="" />
            </div>
            <h2 className='container-text-1'>{headerText}</h2>
            <div className="otp-content">
                <div className='otp-text'>{otpText}</div>
                {phoneNumber && <div className='phone-text'>{`${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6).replaceAll(/\d/g, 'x')}-${phoneNumber.substring(6)}`}</div>}
                {children}
            </div>
            <div className="otp-verfication-footer">
                <div style={{ color: footerTextColor }} className="ref-text">{formattedFooterText}</div>
            </div>
        </>
    )
}

export default OtpVerification
